import React from 'react';

const IndexConcept = (props) => {
  return (
    <div>
      <p className="step-p">The index is the position of the block in the chain.</p>
      
      <p className="step-p">The genesis block has an <strong>index of 0</strong>. The next block will have an index of 1.</p>
    </div>
  );
};

export default IndexConcept;


// WEBPACK FOOTER //
// ./src/steps/index/index-concept.js